
export const paymentMethodsConfig: PaymentMethodsConfig = {
  title: "Payment Methods",
  cards: [
    {
      id: "visa-dark",
      variant: "dark",
      cardNumber: "**** 8942",
      balance: "$28,501.50",
      brand: "VISA",
    },
    {
      id: "visa-light",
      variant: "light",
      cardNumber: "**** 8942",
      balance: "$28,501.50",
      enabled: true,
    },
  ],
};
